module.exports = __webpack_public_path__ + "static/media/bulb.4589522f.png";